<mat-form-field2 class="mat-block" [showLabel]="!inline">
  <app-select
    [required]="ctrl | required"
    [items]="items"
    [searchable]="true"
    [formControl]="ctrl"
    [disabled]="ctrl.disabled"
    bindValue="code"
    bindLabel="name"
    [placeholder]="label"
    [showBlankItem]="showBlankItem"
    [multiple]="multiple"
  >
  </app-select>
  <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')"> {{ label }} is required </mat-error>
</mat-form-field2>
